import { render, staticRenderFns } from "./AiMaterialContent.vue?vue&type=template&id=1ce19645&scoped=true&"
import script from "./AiMaterialContent.vue?vue&type=script&lang=js&"
export * from "./AiMaterialContent.vue?vue&type=script&lang=js&"
import style0 from "./AiMaterialContent.vue?vue&type=style&index=0&id=1ce19645&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce19645",
  null
  
)

export default component.exports